
<template>
    <div class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
        <div class="card-header pb-1">
            <div class="card-title">
                <h4 class="text-center mb-2">{{ $t("message.activate_by_serial") }}</h4>
            </div>
        </div>
        <div class="card-content">
            <div class="card-body">

                <form v-if="!activate_token">
                    <div :class="['form-group', {error : validation.firstError('serial_number')}]">
                        <div class="controls">
                            <label>{{ $t("message.serial_number") }}</label>
                            <input type="text" class="form-control" v-model="serial_number"/>
                            <div class="help-block">{{ validation.firstError('serial_number') }}</div>
                        </div> 
                    </div>        
                    <button type="submit" class="btn btn-primary glow w-100 position-relative" @click.prevent="activate">{{ $t("message.activate") }}<i id="icon-arrow"><font-awesome-icon :icon="['fas', 'arrow-right']"/></i></button>
                    <div class="mt-1 text-right"><a href="#" :class="['card-link',{ disabled : resend_counter}]" class="card-link " @click.prevent="repeat"><small>{{$t("message.repeat_sms")}}<span v-if="resend_counter">({{resend_counter}})</span></small></a></div>
                    <hr>
                <router-link style="position: relative;" class="btn btn-primary btn-block"  :to="{path:'/login'}">{{ $t("message.login")}}<i id="icon-arrow"><font-awesome-icon :icon="['fas', 'arrow-right']"/></i></router-link>
                </form>
                
                <form v-else>
                    <div :class="['form-group', {error : validation.firstError('code')}]">
                        <div class="controls">
                            <label>{{ $t("message.confirm_code") }}</label>
                            <input type="text" class="form-control" v-model="code"/>
                            <div class="help-block">{{ validation.firstError('code') }}</div>
                        </div> 
                    </div> 
                    <div :class="['form-group', {error : validation.firstError('new_password')}]">
                        <div class="controls">
                            <label>{{ $t("message.new_password") }}</label>
                            <div class="input-group">
                                <input :type="!pass_show ? 'password':'text'" class="form-control" v-model="new_password"/>
                                <div class="input-group-append">
                                    <span class="input-group-text" @click="pass_show = !pass_show"><span v-if="pass_show"><font-awesome-icon :icon="['fas', 'eye']"/></span><span v-if="!pass_show" ><font-awesome-icon :icon="['fas', 'eye-slash']"/></span></span>
                                </div>
                            </div>
                            <div class="help-block">{{ validation.firstError('new_password') }}</div>
                        </div>
                        </div> 
                     <div :class="['form-group', {error : validation.firstError('rep_password')}]">
                        <div class="controls">
                            <label>{{ $t("message.confirm_password") }}</label>
                            <div class="input-group">
                                <input :type="!rep_pass_show ? 'password':'text'" class="form-control" v-model="rep_password"/>
                                <div class="input-group-append">
                                    <span class="input-group-text" @click="pass_show = !rep_pass_show"><span v-if="rep_pass_show"><font-awesome-icon :icon="['fas', 'eye']"/></span><span v-if="!pass_show" ><font-awesome-icon :icon="['fas', 'eye-slash']"/></span></span>
                                </div>
                            </div>
                            <div class="help-block">{{ validation.firstError('rep_password') }}</div>
                        </div> 
                         </div> 
                     
                    <div class="form-group">
                        <div class="actions">
                            <button type="button" class=" btn btn-primary glow w-100 position-relative" @click.prevent="confirm">{{ $t("message.activate") }}<i id="icon-arrow"><font-awesome-icon :icon="['fas', 'arrow-right']"/></i></button> 
                            <div class="mt-1 text-right"><a href="#" :class="['card-link',{ disabled : resend_counter}]" class="card-link " @click.prevent="repeat"><small>{{$t("message.repeat_sms")}}<span v-if="resend_counter">({{resend_counter}})</span></small></a></div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div> 
</template>

<script>
    import Validator from '@/formValidator';
    import {error_setter} from '@/formValidator'
    import globalSettings from '@/config.js'
    import axios from 'axios';
    export default{
        name: 'activate-by-serial-form',
        data() {
            return{
                serial_number: null,
                activate_token:null,
                resend_counter:null,
                code:null,
                new_password:null,
                rep_password:null,
                pass_show:null,
                rep_pass_show:null,
            }
        },

        validators: {
            serial_number: function (value) {
                return Validator.value(value).required().minLength(4);
            },
            code:function (value) {
                if (this.activate_token) {
                    return Validator.value(value).required().minLength(5);
                } 
            },
           
            'new_password, rep_password': function (new_password, rep_password) {
                    if (this.submitted || this.validation.isTouched('rep_password')) {
                        return Validator.value(rep_password).required().match(new_password);
                    }
                },        
            rep_password:function (value) {
                if (this.activate_token) {
                    return Validator.value(value).required().minLength(8);
                } 
            },
            new_password:function (value) {
                if (this.activate_token) {
                    return Validator.value(value).required().minLength(8);
                } 
            },
   
        },
        mixins:[error_setter],
        methods: {
            activate: function () {
                 this.$validate().then(valid => {
                    if (valid) {
                        let send_data={
                    lang:this.$i18n.locale,
                    serial_number:this.serial_number,
                }
                axios.post(globalSettings.api_url + 'activate-by-serial', send_data)  
                    .then(response => {   
                        console.log(response.data);
                        if(response.data.activate_token){
                            this.decrease_resend_counter(60)
                             this.activate_token = response.data.activate_token
                             this.$store.dispatch('set_alert',{ always:true, type:'success', text:this.$t('message.sms_code_confirm2')})
                        }else{
                            this.add_external_errors(response.data.errors)
                        } 
                })
                .catch(error => {
                    console.log(error);
                })
                    }
                });

            },
            decrease_resend_counter:function(count){
                if(count){
                    this.resend_counter = count
                }
                if(this.resend_counter && this.resend_counter > 0){
                    this.resend_counter --
                    setTimeout(()=>{this.decrease_resend_counter(false)},1000)
                }else{
                    this.resend_counter = null
                }
            },
            confirm: function () {
                 this.$validate().then(valid => {
                    if (valid) {
                        let send_data={
                            token:this.activate_token,
                            code:this.code,
                            password:this.new_password,
                        }
                        
                        axios.post(globalSettings.api_url + 'activate-by-serial/confirm', send_data)  
                            .then(response => {   
                                if(response.data.token){
                                     this.$store.commit('auth_success', response.data.token)
                                     this.$store.dispatch('init')
                                     .then(()=>{
                                          this.$router.push({ path: '/'})
                                     })
                                     this.$store.dispatch('set_alert',{type:'success', text:this.$t('message.activate_success_message')})
                                }else{
                                     this.add_external_errors(response.data.errors)
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    }
                });

            },
            
            repeat: function () {
                let send_data={
                    token:this.activate_token
                }        
                axios.post(globalSettings.api_url + 'activate-by-serial/repeat', send_data)
                .then(response => {   
                                if(response.data.result){             
                                     this.$store.dispatch('set_alert',{type:'success', text:this.$t('message.repeat_confirm_code_message')})
                                     this.decrease_resend_counter(100)
                                }else{
                                     this.add_external_errors(response.data.errors)
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            })
               

            },
           
            
            
            
        }
    }
</script>

  
            

            